import(/* webpackMode: "eager" */ "/app/src/modules/auth/components/views/Register.tsx")